import "./styles.css";
import PartySocket from "partysocket";

declare const PARTYKIT_HOST: string;

// Messages container height
const MESSAGE_HEIGHT = "300px";

// หา room จาก query string
const url = new URL(window.location.href);
const roomId = url.searchParams.get("room") || "default";
// document.getElementById("room").textContent = "Room: " + roomId;

// Create main container
const container = document.createElement("div");
container.style.display = "flex";
container.style.flexDirection = "column";
container.style.height = "100vh";
container.style.padding = "10px";
document.body.appendChild(container);

// Messages div
const messagesDiv = document.createElement("div");
messagesDiv.id = "messages";
messagesDiv.style.height = MESSAGE_HEIGHT; // fixed height
messagesDiv.style.overflowY = "auto";
messagesDiv.style.border = "1px solid #ccc";
messagesDiv.style.padding = "5px";
messagesDiv.style.marginBottom = "5px";
container.appendChild(messagesDiv);

// Input area
const inputArea = document.createElement("div");
inputArea.style.display = "flex";
inputArea.style.gap = "5px";
container.appendChild(inputArea);

const input = document.createElement("input");
input.type = "text";
input.placeholder = "Type your message...";
input.style.flex = "1";
inputArea.appendChild(input);

const sendBtn = document.createElement("button");
sendBtn.textContent = "Send";
inputArea.appendChild(sendBtn);

// Helper to add message and scroll down
function addMessage(text: string, from: "server" | "me" = "server") {
  const div = document.createElement("div");
  div.textContent = text;
  div.className = from;
  div.style.color = from === "server" ? "green" : "blue";
  messagesDiv.appendChild(div);
  messagesDiv.scrollTop = messagesDiv.scrollHeight; // auto scroll
}

// PartySocket connection
const conn = new PartySocket({
  host: PARTYKIT_HOST,
  room: roomId,
});

conn.addEventListener("open", () => {
  addMessage("Connected!", "server");
});

conn.addEventListener("message", (event) => {
  addMessage(`Server -> ${event.data}`, "server");
});

// Send message
function sendMessage() {
  const msg = input.value.trim();
  if (!msg) return;
  conn.send(msg);
  // addMessage(`Me -> ${msg}`, "me");
  input.value = "";
  input.focus();
}

sendBtn.addEventListener("click", sendMessage);
input.addEventListener("keydown", (e) => {
  if (e.key === "Enter") sendMessage();
});